import { ReactNode } from 'react';
import styles from './grid.module.scss';
import { useExtraClasses } from '@lib/hooks/useExtraClasses';

/**
 * Flex-box grid element to display items.
 * Once at mobile size it will stack the elements instead.
 *
 * @param props - The component props object
 * @param props.children Child elements to be passed into grid
 * @param props.columns Int number of columns in the grid
 * @param props.extraClass string of any extra css classes
 * @returns Grid Element
 *
 * @example
 * ```tsx
 * <Grid columns={3}>
 *      <div>Item 1</div>
 *      <div>Item 2</div>
 *      <div>Item 3</div>
 * </Grid>
 * ```
 */
const Grid = ({
    children,
    columns,
    extraClasses,
}: {
    children: ReactNode;
    columns: 1 | 2 | 3 | 4 | 5 | 6; //Max columns 6
    extraClasses?: string[];
}) => {
    const extraClassString = useExtraClasses(extraClasses, styles);

    return (
        <div
            className={`${styles.grid} ${extraClassString}`}
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }} // create grid columns using inline css
        >
            {children}
        </div>
    );
};

export default Grid;
